import { render, staticRenderFns } from "./ScreeningPortal.vue?vue&type=template&id=fe8afb20&"
import script from "./ScreeningPortal.vue?vue&type=script&lang=js&"
export * from "./ScreeningPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports